import {
  dropShadowLowStyle,
  spacingFluidSmall,
  spacingFluidXSmall,
} from "@porsche-design-system/components-js/styles";
import { useGetTileBaseStyleDrop } from "MainApp/assets/visual/styles/globalStyles/globalJsxStyles";
import { ReactComponent as TuktukSVG } from "../../MainApp/assets/visual/vectors/UI/logos/Tuktuk.svg";
import { ReactComponent as UserSVG } from "../../MainApp/assets/visual/vectors/UI/logos/User.svg";
import React, { useContext, useEffect, useState } from "react";
import "./VitalInfoComponent.css";
import useIsPhone from "MainApp/assets/utils/hooks/useIsPhone";
import { IsRotatedContext } from "MainApp/assets/utils/context/isRotatedContext";
import { useTranslation } from "react-i18next";
import { AuthContext } from "MainApp/assets/utils/context/AuthContext";
import CText from "Components/CComponents/CText/CText";

const VitalInfoComponent = ({ tour }) => {
  const { t } = useTranslation("tourInfo");
  const { isRotated } = useContext(IsRotatedContext);
  const { userData } = useContext(AuthContext);
  const isPhone = useIsPhone();
  const [isTuk, setIsTuk] = useState(false);
  useEffect(() => {
    const checkIframeOrigin = () => {
      try {
        // console.log("Origin:", userData);
        // console.log("Origin:2", userData.data.companyName);
        setIsTuk(userData.data.companyName === "Tuk Tuk World Tours");
      } catch (error) {
        console.error("Error checking origin:", error);
        setIsTuk(false);
      }
    };

    checkIframeOrigin();
  }, [userData]);
  const vitalInfoStyling = {
    height: isPhone ? "100%" : "",
    padding: `0  ${spacingFluidXSmall}  ${spacingFluidXSmall} ${spacingFluidXSmall}`,
    // backgroundColor: !isTuk ? "#0056b3" : "",
  };

  // console.log(userData);

  return (
    <div className="vitalInfo" style={vitalInfoStyling}>
      <div
        style={{
          minHeight: isPhone
            ? isRotated
              ? "16vh"
              : "8vh"
            : isRotated
            ? "8vh"
            : "3vh",
          ...useGetTileBaseStyleDrop(),
          ...dropShadowLowStyle,
          padding: spacingFluidSmall,
        }}
      >
        <CText weight="bold">{t("price_text") || "Loading..."}</CText>
        <CText className="flex justify-center" size="medium">
          {tour.price}€
        </CText>
      </div>

      <div
        className="vehicleInfo"
        style={{
          minHeight: isPhone
            ? isRotated
              ? "16vh"
              : "8vh"
            : isRotated
            ? "8vh"
            : "3vh",
          ...useGetTileBaseStyleDrop(),
          ...dropShadowLowStyle,
          padding: spacingFluidXSmall,
        }}
      >
        <TuktukSVG className="tuktukSVG" />
        <CText>&nbsp;&nbsp;=&nbsp;</CText>
        <UserSVG className="personSVG" />
        <CText>{userData?.data?.max_people || "4"}</CText>
      </div>
    </div>
  );
};

export default VitalInfoComponent;
